import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import { getCompassRequestAccessUrl } from '@atlassiansox/compass-component-card-list';

import { publishUiEvent } from 'src/utils/analytics/publish';

import messages from './messages';

export type ComponentCardPermissionErrorStateProps = {
  cloudId: string;
};

const boxStyles = xcss({
  display: 'flex',
  padding: 'space.200',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
});

export const ComponentCardPermissionErrorState = ({
  cloudId,
}: ComponentCardPermissionErrorStateProps) => {
  const { formatMessage } = useIntl();

  return (
    <Box xcss={boxStyles}>
      <p>
        <strong>{formatMessage(messages.titleText)}</strong>
      </p>
      <p>
        {formatMessage(messages.descriptionText)}{' '}
        <a
          data-testid="compass.component-card-list.error-state.permissions-error.learn-more-link"
          href="https://support.atlassian.com/bitbucket-cloud/docs/link-repositories-to-compass-components/"
          target="_blank"
          rel="noopener"
          onClick={() => {
            publishUiEvent({
              action: 'clicked',
              source: 'componentCardSearchList',
              actionSubject: 'permissionsErrorStateLearnMoreLink',
            });
          }}
        >
          {formatMessage(messages.learnMore)}
        </a>
      </p>
      <p>
        <Button
          testId="compass.component-card-list.error-state.permissions-error.request-access-link"
          role="button"
          href={getCompassRequestAccessUrl(cloudId)}
          appearance="link"
          spacing="none"
          style={{ alignItems: 'center' }}
          target="_blank"
          rel="noopener"
          onClick={() => {
            publishUiEvent({
              action: 'clicked',
              source: 'componentCardSearchList',
              actionSubject: 'permissionsErrorStateLinkComponentLink',
            });
          }}
        >
          {formatMessage(messages.requestAccess)}
        </Button>
      </p>
    </Box>
  );
};
